export function pageview( url ) {
  return {
    type: 'GOOGLE_ANALYTICS_PAGEVIEW',
    payload: { url: url }
  };
}

export function modalview( url ) {
  return {
    type: 'GOOGLE_ANALYTICS_MODALVIEW',
    payload: { url: url }
  };
}

export function event( category, label, action ) {
  return {
    type: 'GOOGLE_ANALYTICS_EVENT',
    payload: { category: category, label: label, action: action }
  };
}


// WEBPACK FOOTER //
// ./src/redux/actions/google.js